import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show the sticky CTA after scrolling past the hero section (approx 400px)
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] z-50 animate-in slide-in-from-bottom-full duration-300" data-id="element-97">
      <a href="https://trackrt.activapleno.com/click" className="block w-full decoration-transparent" data-id="element-98">
        <Button fullWidth size="lg" className="shadow-lg" data-id="element-99">
          Compare Prices Now &rarr;
        </Button>
      </a>
    </div>;
}